module.exports = __webpack_public_path__ + "img/ico_exclamination.a8e4dd30.svg";